module.exports = __webpack_public_path__ + "img/ic24Foot.7f123ff1.svg";